
import axios from 'axios';
import { authStorage } from './auth';


const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.mobinity.in/';

const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*',
        'DEVICE-TYPE': 'Web',
        'VER': '1',
    },
});

apiClient.interceptors.request.use(config => {
    const token = authStorage.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// apiClient.js mein add karo
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            return Promise.resolve(error.response);
        }
        return Promise.reject(error);
    }
);

export default apiClient;